import { Detection } from 'src/data-capture/types';
import { DetectionState, EntityCategory, Categories } from '../useDetectedEntitiesStore';
import { detectedEntityId } from './detectedEntityId';
import extractCategoriesForDetection from './extractCategoriesForDetection';
import { heldFeedFieldsByConflict } from './heldFeedFields';
import { JOINT_FIELD, takeJointAnswer } from './jointAnswer';

export const getUpdatedDetectionState = (
  existingDetectionState: DetectionState,
  refetchedDetection: Detection,
): DetectionState => {
  const { detection: newDetection, detectedJoint } = existingDetectionState.jointDecidedBySwitch
    ? takeJointAnswer(refetchedDetection)
    : { detection: refetchedDetection, detectedJoint: undefined };
  const updatedState: DetectionState = {
    ...existingDetectionState,
    detectedJoint,
  };

  const updatedFieldsByKey = { ...existingDetectionState.fieldsByKey };
  Object.keys(updatedFieldsByKey).forEach(fieldName => {
    if (
      newDetection.entity.fields[fieldName] !== undefined &&
      !updatedFieldsByKey[fieldName].isLocallyEdited
    ) {
      updatedFieldsByKey[fieldName] = {
        ...updatedFieldsByKey[fieldName],
        value: newDetection.entity.fields[fieldName],
      };
    }
  });

  updatedState.fieldsByKey = updatedFieldsByKey;
  updatedState.entityId = detectedEntityId(newDetection);
  updatedState.conflicts = newDetection.conflicts.map(c => ({
    id: c.conflictingEntityFields.id,
    conflictingEntityFields: c.conflictingEntityFields,
    conflictingFields: c.conflictingFields,
    existingOwners: c.conflictingEntityFields.owners,
    existingJoint: c.conflictingEntityFields[JOINT_FIELD],
  }));
  updatedState.heldFeedFields = heldFeedFieldsByConflict(newDetection);

  return updatedState;
};

export const addToCategories = (
  existingCategories: Categories,
  newCategoriesForDetection: ReturnType<typeof extractCategoriesForDetection>,
  entityType: string,
  detectionId: string,
) => {
  Object.entries(newCategoriesForDetection).forEach(([category, categoryData]) => {
    const categoryKey = category as EntityCategory;

    if (!existingCategories[categoryKey][entityType]) {
      existingCategories[categoryKey][entityType] = {};
    }

    existingCategories[categoryKey][entityType][detectionId] = categoryData;
  });
};
